<template>
    <v-dialog v-model="props.dialog_parent" max-width="750px" v-on:click:outside="closeDialogChild">
        <v-card>
            <v-card-title class="bg-blue-darken-2">
                <h2 class="text-h4 text-center">Dotación Pistola</h2>
            </v-card-title>

            <v-card-title>
                <span class="text-h5">
                    <v-icon icon="mdi-pencil" size="samll" color="blue-darken-2 as-scale"></v-icon>
                    {{ props.formTitleParent }}
                </span>
            </v-card-title>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn variant="outlined" @click="closeDialogChild()" color="red">
                    <v-icon icon="mdi-file-cancel-outline"></v-icon>&nbsp;Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from "vue";


export default defineComponent({
    props: [
        "dialog_parent",
        "registro_parent",
        "formTitleParent",
        "errors_validate_parent",
    ],
    emits: ["closeDialogParent", "saveParent"],
    setup(props, { emit }) {
        const closeDialogChild = () => {
            emit("closeDialogParent");
        };
        const saveChild = () => {
            emit("saveParent");
        };
        return { props, closeDialogChild, saveChild };
    },
});
</script>
